export const getVerificationTypesLoaded = state => {
  return state.dictionaries.verificationTypes && state.dictionaries.verificationTypes.isLoaded;
};

export const getVerificationTypes = state => {
  if (state.dictionaries.verificationTypes.isLoaded) {
    const verificationTypes = JSON.parse(JSON.stringify(state.dictionaries.verificationTypes.items));

    return verificationTypes;
  }

  return [];
};
